module.exports = __webpack_public_path__ + "assets/img/img_henan.e00af5ac.png";